import { render, staticRenderFns } from "./MdocksGrid.vue?vue&type=template&id=11d59480"
import script from "./MdocksGrid.vue?vue&type=script&lang=js"
export * from "./MdocksGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports